<script>
import ControlTemp from "@/views/Control/Temp.vue"

export default {
  name: "View",
  mixins: [ControlTemp]
}
</script>